import React from "react";
import { ShieldIcon, CameraIcon, MicIcon, NavigationIcon } from "./PrivacyIcons";

const PERMISSION_ITEMS = [
  {
    id: "camera",
    label: "Camera Access",
    desc: "Allow access to camera",
    icon: CameraIcon,
  },
  {
    id: "microphone",
    label: "Microphone Access",
    desc: "Allow access to microphone",
    icon: MicIcon,
  },
  {
    id: "location",
    label: "Location Access",
    desc: "Allow access to location",
    icon: NavigationIcon,
  },
];

const PrivacyPermissionsCard = ({ permissions, setPermissions }) => {
  const toggle = (id) => {
    setPermissions((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div className="v2-privacy-pg-card">
      <div className="v2-privacy-pg-card__header">
        <div className="v2-privacy-pg-card__icon-wrap" style={{ background: "#fef2f2" }}>
          <ShieldIcon size={20} color="#eb1414" />
        </div>
        <div>
          <h3 className="v2-privacy-pg-card__title">Permissions</h3>
          <p className="v2-privacy-pg-card__subtitle">
            Manage app permissions on this device
          </p>
        </div>
      </div>
      <div className="v2-privacy-pg-card__body">
        {PERMISSION_ITEMS.map((item) => {
          const Icon = item.icon;
          const isOn = permissions[item.id];
          return (
            <div className="v2-privacy-pg-toggle-item" key={item.id}>
              <div className="v2-privacy-pg-toggle-item__left">
                <div className="v2-privacy-pg-toggle-item__icon">
                  <Icon size={18} color="#eb1414" />
                </div>
                <div className="v2-privacy-pg-toggle-item__text">
                  <span className="v2-privacy-pg-toggle-item__label">{item.label}</span>
                  <span className="v2-privacy-pg-toggle-item__desc">{item.desc}</span>
                </div>
              </div>
              <button
                className={`v2-privacy-pg-toggle${isOn ? " v2-privacy-pg-toggle--on" : ""}`}
                onClick={() => toggle(item.id)}
              >
                <span className="v2-privacy-pg-toggle__knob" />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PrivacyPermissionsCard;
